import React from "react";
import IdCardSkeleton from "./IdCardSkeleton";

const IdCardSkeletonStack: React.FC = () => {
  return (
    <div className="mx-auto flex w-full mt-7 justify-center px-[1.5rem] min-[450px]:px-[2rem] ">
      <div className="relative h-[228px] w-full zoom-large-screen">
        <div className="absolute inset-x-0 top-0 z-10">
          <IdCardSkeleton bgColor="bg-[darkgray]" />
        </div>
        <div className="absolute inset-x-[4px] top-[60px] z-0">
          <IdCardSkeleton bgColor="bg-[#606060]" />
        </div>
      </div>
    </div>
  );
};

export default IdCardSkeletonStack;
